/* Publish by EComposer at 2026-10-10 20:10:46*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-gaym1eobjr"]=  window.__ectimmers["ecom-gaym1eobjr"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-gaym1eobjr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gaym1eobjr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-atbfbhew00h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-atbfbhew00h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-knkh3l50029').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-knkh3l50029', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-14n5dgq41fn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-14n5dgq41fn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ndod727dtv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ndod727dtv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ylrqmzmd5l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ylrqmzmd5l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zbu873n5s1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zbu873n5s1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sf5mndi9mlc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sf5mndi9mlc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7xehntp6pta').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7xehntp6pta', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qwce51iwuun').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qwce51iwuun', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e8hysdeu61o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e8hysdeu61o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y5y59vanyf9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y5y59vanyf9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6p8qf1bqkui').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6p8qf1bqkui', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-105l4qccnfd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-105l4qccnfd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h612ekrhqg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h612ekrhqg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-taw8np4fh0q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-taw8np4fh0q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-znv9qoo69lb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-znv9qoo69lb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-58qmhoegdqh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-58qmhoegdqh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1vrsnakc4o9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1vrsnakc4o9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u9zfu4e1kzg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u9zfu4e1kzg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-79mtwsvqqd6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-79mtwsvqqd6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zfu7s8s6j9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zfu7s8s6j9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dwdlfg187c9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dwdlfg187c9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p3g163bpyq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p3g163bpyq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ydpph07411l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ydpph07411l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o8umlx6igu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o8umlx6igu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ulyeqez600g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ulyeqez600g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jgflk3g948h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jgflk3g948h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j8lq78wmgr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j8lq78wmgr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rxbs2owmvl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rxbs2owmvl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3678xk32bzg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3678xk32bzg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cnhfltyt57').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cnhfltyt57', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gzen5m9n36o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gzen5m9n36o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-loznexkgcxq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-loznexkgcxq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-npckxmgterm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-npckxmgterm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-85o45ysh0i8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-85o45ysh0i8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-47wl26ufw64').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-47wl26ufw64', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dw5b1przjop').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dw5b1przjop', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dxsbgo7xi1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dxsbgo7xi1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ujy8xbh7w6m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ujy8xbh7w6m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oees1pizzqj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oees1pizzqj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f3hpe8fnlsp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f3hpe8fnlsp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bvmugj0yc28').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bvmugj0yc28', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-91u3i2puv7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-91u3i2puv7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-orc7b8e42s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-orc7b8e42s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9gal09qshv7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9gal09qshv7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kd2kw6cw8db').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kd2kw6cw8db', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x4duqgbk9b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x4duqgbk9b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q7kk0nqjmic').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q7kk0nqjmic', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t5a6qzbb7yi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t5a6qzbb7yi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1dycwh6eukn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1dycwh6eukn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7bcgpvh3led').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7bcgpvh3led', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gbrzw2hhxk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gbrzw2hhxk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4g2ydsecqe7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4g2ydsecqe7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lmhkxsg5d6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lmhkxsg5d6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ybyuyg25ufn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ybyuyg25ufn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-di5mc2rxs36').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-di5mc2rxs36', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v9sizmjajq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v9sizmjajq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wkym4rl75tr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wkym4rl75tr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m3uvsxfzil').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m3uvsxfzil', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oz14wj0a4os').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oz14wj0a4os', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3sorurgq6al').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3sorurgq6al', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-poaefa960mi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-poaefa960mi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n903yyv4xge').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n903yyv4xge', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kl1chown2ik').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kl1chown2ik', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-64nhv3w8kjv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-64nhv3w8kjv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xzmidnz5h8h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xzmidnz5h8h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wx9lojclh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wx9lojclh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b9tvtaivl7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b9tvtaivl7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sc0a6761cec').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sc0a6761cec', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fsog1usba3m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fsog1usba3m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iv4omnu5a6a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iv4omnu5a6a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ke0on7bbfy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ke0on7bbfy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-13ah95r07ed').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-13ah95r07ed', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-72py5eeyr0s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-72py5eeyr0s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-haewi3z6yd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-haewi3z6yd', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-xnojdicoyjp"]=  window.__ectimmers["ecom-xnojdicoyjp"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const o=t.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-xnojdicoyjp"]["mpkpawi68"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let o=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const n=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},o);try{Shopify.analytics.publish("ec_custom_events",n)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-xnojdicoyjp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xnojdicoyjp', settings: {"animation":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x82kxaqedd9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x82kxaqedd9', settings: {"animation":true},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-uaiqqoqimoe"]=  window.__ectimmers["ecom-uaiqqoqimoe"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-uaiqqoqimoe"]["aluiv8nhe"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let o=this.$el;if(!o)return;function n(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function s(){let r=o.querySelector(".ecom-element.ecom-base-image"),a=o.closest(".core__row--columns");r&&(n(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){s()})

                    });
                    
                        document.querySelectorAll('.ecom-uaiqqoqimoe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uaiqqoqimoe', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jadzz0yjxbl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jadzz0yjxbl', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7c7uarqczct').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7c7uarqczct', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kdlaqt69ei').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kdlaqt69ei', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tin8kyxbk4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tin8kyxbk4', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-watf6pu8h0e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-watf6pu8h0e', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6b95gxsddn6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6b95gxsddn6', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0xrxpa7gvl2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0xrxpa7gvl2', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wbfxprd9sr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wbfxprd9sr', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9pmlvi0zakr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9pmlvi0zakr', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2bpyq9p3n9h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2bpyq9p3n9h', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-63xlzukvl1u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-63xlzukvl1u', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mzufdqfbgca').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mzufdqfbgca', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-85svwvis60m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-85svwvis60m', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o3qfawsl81').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o3qfawsl81', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 if (window.location.hash.includes('codeapplied')) {
jQuery('body').find('#mother-code span.ecom__element--button-icon-text.ecom-html').text('CODE APPLIED');
  jQuery('body').find('#mother-code2 span.ecom__element--button-icon-text.ecom-html').text('CODE APPLIED');
}
} catch(error){console.error(error);}